import { render, staticRenderFns } from "./CounselorLookupInput.vue?vue&type=template&id=ca290caa&"
import script from "./CounselorLookupInput.vue?vue&type=script&lang=js&"
export * from "./CounselorLookupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports